import { GRadio } from 'components/basic-blocks/g-radio'
import { BlockingModeProps } from './types'

export const BlockingMode = ({
	blockingMode,
	setBlockingMode
}: BlockingModeProps) => {
	return (
		<div className='mb-2'>
			<div className="text-t-default text-md flex flex-row items-center gap-x-1 mb-4">
				<span className="font-medium">Protective actions</span>
			</div>
			<div className="flex flex-col space-y-2">
				<GRadio
					name="monitoring"
					checked={blockingMode === 'monitoring'}
					label="Monitoring only"
					onChange={(e) => setBlockingMode(e.target.value)}
					value="monitoring"
					labelClass="text-t-default font-normal"
					helpToolTip="Log all traffic and flag suspicious clicks without modifying your ad accounts targeting settings."
				/>
				<GRadio
					name="block"
					checked={blockingMode === 'block'}
					label="Block attackers and unwanted traffic"
					onChange={(e) => setBlockingMode(e.target.value)}
					value="block"
					labelClass="text-t-default font-normal"
					helpToolTip="Fully optimize traffic by reducing both fraudulent actors and bad quality traffic from interacting with your ads. Creates blacklist records for longer, more effective blocking."
				/>
			</div>
		</div>
	)
}
